// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__VR7tK","approved":"Status_approved__3wKcQ","rejected":"Status_rejected__1Fyy6","expired":"Status_expired__1fTm7","label":"Status_label__2Y49-"};